export enum GrowthBookFeatures {
  ALL_TOURS_COMPONENT = 'all-tours-component',
  CHOOSE_FLIGHTS = 'choose-flights-to-continue',
  WHATS_INCLUDED = 'hotel-landing-whats-included',
  FILTERS_LEFT = 'filters-left'
}
